import { motion } from "framer-motion";

export default function FloatingCTA({
  label,
  onClick,
  variant = "primary",
  icon: Icon,
  disabled,
  testid,
  hint,
  withBottomNav = false,
}) {
  const bg = variant === "primary" ? "var(--accent-blue)" : variant === "green" ? "var(--accent-green)" : "var(--text-primary)";
  const fg = variant === "primary" || variant === "green" ? "#000" : "#fff";

  return (
    <div
      className="fixed left-0 right-0 px-5 cta-backdrop"
      style={{
        bottom: withBottomNav ? "calc(64px + env(safe-area-inset-bottom))" : 0,
        paddingBottom: withBottomNav ? "16px" : "calc(env(safe-area-inset-bottom) + 16px)",
        paddingTop: 28,
        zIndex: 50,
      }}
    >
      <motion.button
        type="button"
        onClick={onClick}
        disabled={disabled}
        data-testid={testid}
        whileTap={{ scale: 0.97 }}
        className="w-full max-w-2xl mx-auto flex items-center justify-center gap-2 rounded-pill h-13 transition-all disabled:opacity-50"
        style={{
          background: bg,
          color: fg,
          height: 52,
          borderRadius: 100,
          fontFamily: "Manrope",
          fontWeight: 700,
          fontSize: 16,
          letterSpacing: "-0.005em",
          boxShadow: "var(--shadow-float)",
        }}
      >
        {Icon ? <Icon size={20} strokeWidth={2.2} /> : null}
        <span>{label}</span>
      </motion.button>
      {hint ? (
        <p className="text-center text-[12px] text-ink-muted mt-2 max-w-2xl mx-auto">{hint}</p>
      ) : null}
    </div>
  );
}
